import axios from "./axios";

export interface LoginRequestBody {
  token: string;
}
export interface LoginRequestV2Body {
  email: string;
  password: string;
}

export interface NewUserBody {
  name: string;
  password: string;
  email: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
}

export const login = async (body: LoginRequestBody): Promise<LoginResponse> => {
  const response = await axios.post("/auth/login", body);
  return response.data;
};

export const createAccountAPI = async (body: NewUserBody) => {
  const response = await axios.post("/auth/register", body);
  return response;
};

export const loginByAccount = async (body: LoginRequestV2Body) => {
  const response = await axios.post("/auth/login", body);
  return response.data;
};

export interface RefreshTokenBody {
  refreshToken: string;
}

export interface RefreshTokenResponse {
  accessToken: string;
  refreshToken: string;
}

export const sendRefreshToken = async (
  refresh_token: RefreshTokenBody
): Promise<RefreshTokenResponse> => {
  const response = await axios.post<LoginResponse>(
    "/auth/refresh-token",
    refresh_token
  );
  return response.data;
};

export interface ForgotPasswordBody {
  email: string;
}

// Always resolves with a generic message regardless of whether the email
// exists (the server never reveals it — prevents account enumeration).
export const forgotPassword = async (body: ForgotPasswordBody) => {
  const response = await axios.post("/auth/forgot-password", body);
  return response.data as { message: string };
};

export interface ResetPasswordBody {
  token: string;
  password: string;
}

export const resetPassword = async (body: ResetPasswordBody) => {
  const response = await axios.post("/auth/reset-password", body);
  return response.data as { message: string };
};

